<div class="resins">
  <h2>{{ translationService.getResinsText() }}</h2>
  @for (resinCtrl of resinsArray.controls; track resinCtrl; let i = $index) {
    <div class="custom-form-row" [formGroup]="resinCtrl">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{ translationService.getNAPCSTypeText() }}</mat-label>
        <mat-select formControlName="napcsCodeId">
          @for (code of napcsCodes; track code.id) {
            <mat-option [value]="code.id">
              {{ code.fullResinTitle }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{ translationService.getSourceTypeText() }}</mat-label>
        <mat-select formControlName="sourceType">
          @for (opt of sourceTypes | keyvalue; track opt.key) {
            <mat-option [value]="opt.key">
              {{ opt.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-sm" appearance="outline">
        <mat-label>{{ translationService.getResinWeightKgText() }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          step="0.001"
          formControlName="weightPerUnitKg"
          autocomplete="off"
        />
      </mat-form-field>

      <button
        mat-icon-button
        type="button"
        (click)="removeResin(i)"
        aria-label="Remove resin"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }

  <button mat-raised-button color="accent" type="button" (click)="addResin()">
    <mat-icon>add</mat-icon>
    {{ translationService.getAddResinText() }}
  </button>
</div>
